module.exports = __webpack_public_path__ + "img/A5-7-plan.bb24627d.png";